import type { UntypedFormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import type { OnInit } from '@angular/core';
import type { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import type { ETime } from '@common/enums';

import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { dateTimeUnitMap } from './conts/datetime-slider.conts';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sp-datetime-slider',
    templateUrl: './sp-datetime-slider.component.html',
    styleUrls: ['./sp-datetime-slider.component.less'],
    imports: [CommonModule, ReactiveFormsModule, NgxSliderModule],
})
export class SpDatetimeSliderComponent implements OnInit {
    private readonly fb = inject(UntypedFormBuilder);
    private readonly translate = inject(TranslateService);

    @Input() public columns: ETime[];
    @Output() public changeColumns = new EventEmitter<ETime[]>();

    public sliderForm: UntypedFormGroup;
    public readonly options: Options = {
        showTicks: true,
        stepsArray: [
            {
                value: 1,
                legend: this.translate.instant('days'),
            },
            {
                value: 2,
                legend: this.translate.instant('hours'),
            },
            {
                value: 3,
                legend: this.translate.instant('minutes'),
            },
            {
                value: 4,
                legend: this.translate.instant('seconds'),
            },
        ],
    };

    constructor() {
        this.initForm();
    }

    ngOnInit(): void {
        this.setFormData();
    }

    private initForm(): void {
        this.sliderForm = this.fb.group({
            sliderControl: null,
        });
    }

    private setFormData(): void {
        const columns = this.columns.map((column) => {
            return dateTimeUnitMap[column];
        });

        const min = Math.min(...columns);
        const max = Math.max(...columns);

        this.sliderForm.get('sliderControl').patchValue([min, max], { emitEvent: false });
    }

    public onChangeEnd(changeContext: ChangeContext): void {
        let changeContextValue = changeContext.value;
        const columns = [];

        while (changeContextValue <= changeContext.highValue) {
            columns.push(Object.keys(dateTimeUnitMap).find((key) => dateTimeUnitMap[key] === changeContextValue));
            changeContextValue += 1;
        }

        this.changeColumns.emit(columns);
    }
}
